/** Short WebAudio cue for parallel-ticket operator warnings (no asset file). */

let sharedCtx: AudioContext | null = null

function getCtx(): AudioContext | null {
  if (typeof window === 'undefined') return null
  const AudioCtx = window.AudioContext
  if (!AudioCtx) return null
  try {
    sharedCtx = sharedCtx ?? new AudioCtx()
    if (sharedCtx.state === 'suspended') {
      void sharedCtx.resume().catch(() => undefined)
    }
    return sharedCtx
  } catch {
    return null
  }
}

function beep(ctx: AudioContext, frequency: number, startAt: number, duration: number, peak = 0.06) {
  const osc = ctx.createOscillator()
  const gain = ctx.createGain()
  osc.type = 'sine'
  osc.frequency.setValueAtTime(frequency, startAt)
  gain.gain.setValueAtTime(0.0001, startAt)
  gain.gain.exponentialRampToValueAtTime(peak, startAt + 0.015)
  gain.gain.exponentialRampToValueAtTime(0.0001, startAt + duration)
  osc.connect(gain)
  gain.connect(ctx.destination)
  osc.start(startAt)
  osc.stop(startAt + duration + 0.02)
}

/** hot = urgent double beep; warm = softer single tone */
export function playParallelTicketAlertSound(severity: 'hot' | 'warm' | string) {
  const ctx = getCtx()
  if (!ctx) return
  try {
    const now = ctx.currentTime
    if (severity === 'hot') {
      beep(ctx, 880, now, 0.16, 0.07)
      beep(ctx, 1175, now + 0.2, 0.18, 0.07)
    } else {
      beep(ctx, 660, now, 0.22, 0.05)
    }
  } catch {
    /* ignore autoplay / audio errors */
  }
}
